import DrawBase from "../DrawBase"
import EditWall from "./EditWall"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawWall extends DrawBase {
    constructor(options) {
        super(options);
        this.minimumHeights = 0;
        this.maximumHeights = 100;
    }

    getEditInterface() {
        return EditWall;
    }

    getTypeName() {
        return "墙体";
    }

    getType() {
        return "wall_Nor";
    }

    checkMouseMove() {
        if (this.positionsTemp.length < 1) {
            return false;
        }
        return true;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
                return positionsArr;
            }
            return positionsArr ? positionsArr : $this.positions;
        }, false);

        var minimumHeights = new $this.Cesium.CallbackProperty(function () {
            var list = new Array($this.positions.length);
            for (var i = 0; i < $this.positions.length; i++) {
                var carto = Cesium.Cartographic.fromCartesian($this.positions[i]);
                var heightTerrain = $this.viewer.scene.globe.getHeight(carto);
                list[i] = heightTerrain;
            }

            return list;

        })

        var maximumHeights = new $this.Cesium.CallbackProperty(function () {
            var list = new Array($this.positions.length);
            for (var i = 0; i < $this.positions.length; i++) {
                var carto = Cesium.Cartographic.fromCartesian($this.positions[i]);
                var heightTerrain = $this.viewer.scene.globe.getHeight(carto);
                list[i] = heightTerrain + $this.maximumHeights;
            }

            return list;

        })

        var wall = this.createWall(positionsProperty, minimumHeights, maximumHeights);
        entity.wall = wall;
    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var positionsArr = JSON.parse(data.editPositions);
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            return positionsArr;
        }, true);

        var minimumHeights = 0;
        var maximumHeights = 1;

        var wall = this.createWall(positionsProperty, minimumHeights, maximumHeights);
        entity.wall = wall;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "wall")
    }
}


export default DrawWall;